module.exports = __webpack_public_path__ + "8cd10170c603518d3f9c064ad6252ae4.svg";